import React, { useContext } from 'react';
import { FieldTable, MxColumnType, MxColumnsType } from '@maxtropy/components';
import { PointContext, PointContextProps } from '../../../contextTypes';
import { getColumns } from './columns';
import { EdgeDeviceTemplatePoint } from './index';
import { DataPointType, DataProperty } from '../../../../../types';
import { uniqueId } from 'lodash-es';

interface ModbusPointBaseProps {
  fixed?: boolean;
  loading?: boolean;
  editColumns?: MxColumnsType<EdgeDeviceTemplatePoint>;
  dataPropertiesAll?: DataProperty[];
}

export const getIndexColumn = (fixed?: boolean): MxColumnType<EdgeDeviceTemplatePoint> => {
  return {
    title: '序号',
    width: 70,
    fixed: 'left',
    render: (_, record, index) => index + 1,
  };
};

const ModbusPointBase: React.FC<ModbusPointBaseProps> = props => {
  const { fixed, loading, editColumns } = props;

  const { dataSource, canAdjustField } = useContext(PointContext) as PointContextProps<EdgeDeviceTemplatePoint>;

  return (
    <FieldTable
      sticky
      loading={loading}
      scroll={{ y: 500 }}
      rowKey={uniqueId()}
      cacheKey="thirdPoint"
      adjustField={canAdjustField}
      adjustWidth={canAdjustField}
      dataSource={dataSource?.filter(item => item.pointType === DataPointType.BASE_POINT)}
      columns={[
        getIndexColumn(fixed),
        ...getColumns(!canAdjustField ? [] : editColumns),
        ...(canAdjustField ? [] : editColumns || []),
      ]}
    />
  );
};

export default ModbusPointBase;
